import React from 'react'
import { SideBar } from '../components/admin/sideBar'
import { AdminRoute } from './../routes/adminRoute'
import { AdminNavBar } from '../components/admin/adminNavBar'

function Admin() {
    return (
        <div className="wrapper">
            <SideBar></SideBar>
            <div className="main-panel">
                <AdminNavBar></AdminNavBar>
                <AdminRoute></AdminRoute>
            </div>
        </div>
    )
}

export { Admin }